import { render, staticRenderFns } from "./HistoricalDataSubsystem.vue?vue&type=template&id=119ab649"
import script from "./HistoricalDataSubsystem.vue?vue&type=script&lang=js"
export * from "./HistoricalDataSubsystem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports